import * as types from "../Actions/Types";
import { ITerritoryTypePermission } from "../Models/Models";

export interface ITerritoryManagementStore {
  territoryTypePermissions: Array<ITerritoryTypePermission>;
}
const defaultState: ITerritoryManagementStore = {
    territoryTypePermissions: [],
};

export const territoryManagement = (
    territoryManagementStore: ITerritoryManagementStore = { ...defaultState },
    action
): ITerritoryManagementStore => {
    switch (action.type) {
        case types.GET_TERRITORY_TYPE_PERMISSIONS_SUCCESS: {
            return {
                ...territoryManagementStore,
                territoryTypePermissions: action.response.data,
            };
        }

        case types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_SUCCESS: {
            const territoryManagementStoreTypePermissionsCopy: ITerritoryTypePermission[]
        = [...territoryManagementStore.territoryTypePermissions];
            let foundIt = false;
            for (
                let i = 0;
                i < territoryManagementStoreTypePermissionsCopy.length;
                i++
            ) {
                if (
                    territoryManagementStoreTypePermissionsCopy[i].userID
          === action.response.data.userID
                ) {
                    foundIt = true;
                    territoryManagementStoreTypePermissionsCopy[i].canView
            = action.response.data.canView;
                    territoryManagementStoreTypePermissionsCopy[i].canEdit
            = action.response.data.canEdit;

                    // update SCOUT
                    const context = (window as any).scout.context;
                    context.getFranchiseeTerritories(action.response.data.userID);
                    break;
                }
            }

            if (!foundIt) {
                const obj: ITerritoryTypePermission = {
                    typeID: action.response.data.typeID,
                    canView: action.response.data.canView,
                    canEdit: action.response.data.canEdit,
                    userID: action.response.data.userID,
                };
                territoryManagementStoreTypePermissionsCopy.push(obj);
            }

            return {
                ...territoryManagementStore,
                territoryTypePermissions: territoryManagementStoreTypePermissionsCopy,
            };
        }

        case types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FOR_ALL_SUCCESS: {
            return {
                ...territoryManagementStore,
                territoryTypePermissions: action.response.data,
            };
        }

        // FAILURE
        case types.UPDATE_TERRITORY_TYPE_ADMIN_ONLY_FAILURE: // success handled in the user reducer
        case types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FAILURE:
        case types.GET_TERRITORY_TYPE_PERMISSIONS_FAILURE: {
            console.log(action);
        }

        default:
            return territoryManagementStore;
    }
};
